import React, { useState , useRef} from 'react';

import './styling/Home.css'; // Import your CSS file for styling
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';



const HomepgSliders = ({ heading, slides }) => {

    const sliderRef = useRef();
    
    const [slideIndex] = useState(0);
    const products_prev = () => {
      sliderRef.current.slickPrev();
      sliderRef.current.slickPlay();
    };
  
    const products_next = () => {
      sliderRef.current.slickNext();
      sliderRef.current.slickPlay();
    };

      const items_slider = {
    infinite: true,
    speed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
      };



    return(
    <div className="section3">
        <h1>{heading}</h1>
        <div className="slider-container">
        <Slider  ref={sliderRef} {...items_slider}>
          
        {slides.map((slide, index) => (
          <div
          className={`slide ${slideIndex === index ? 'active' : ''}`}
          key={index}
          >
            <img src={slide.image} alt={`Image ${index + 1}`} />
            <div className='product_caption'>{slide.caption}</div>
          </div>
        ))}

      </Slider>
      <div>
        <button className='products_prev' onClick={products_prev}>&#10094;</button>
        <button className='products_next'  onClick={products_next}>&#10095;</button>
      </div>
      </div>
          </div>

    );
};


export default HomepgSliders;